/* eslint-disable react-hooks/exhaustive-deps */
import {
  Card,
  Col,
  Input,
  List,
  Row,
  Select,
  Badge,
  Spin,
  Typography,
  Tag,
  Radio,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import Layout from '../../layouts/User';
import styles from './index.module.scss';
import { useSearchParams } from 'react-router-dom';
import { BASE_URL, DEFAULT_PRODUCT_URL } from '../../config';
import { useNavigate } from 'react-router-dom';
import { convertPrice, shopDeliveryText } from '../../utils/display';
import NumberFormat from 'react-number-format';
import ProductItem from './_product_item';
import { Link } from 'react-router-dom';

const { Paragraph } = Typography;
const { Search } = Input;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Shop: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const [searchParams] = useSearchParams();
  const [shopProducts, setShopProducts] = useState<any>([]);
  const [shopDetail, setShopDetail] = useState<any>([]);
  const [shopId, setShopId] = useState<any>('');
  const [isMember, setIsMember] = useState<any>(false);
  const [allCategory, setAllCategory] = useState<any>([]);
  const [category, setCategory] = useState<string>('all');
  const [ordering, setOrdering] = useState<string>('promotion');
  const [loading, setLoading] = useState<boolean>(false);
  const [hasProducts, setHasProducts] = useState<boolean>(true);
  const [search, setSearch] = useState<string>('');
  const [skip, setSkip] = useState<number>(1);
  const [categoryOption, setCategoryOption] = useState<any>([]);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [shopPromotion, setShopPromotion] = useState<any>([]);
  const [fromPage, setFromPage] = useState<any>('');
  const [navigateBarName, setNavigateBarName] = useState<any>();
  const [navigateBarUrl, setNavigateBarUrl] = useState<any>();
  const [promotionProducts, setPromotionProducts] = useState<any>([]);
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      text: 'หน้าหลัก',
      path: '/',
    },
    {
      text: navigateBarName ? `${navigateBarName}` : '',
      path: `${navigateBarUrl}`,
    },
    {
      text: shopDetail?.shop?.name,
    },
  ];

  const limit = 10;

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  const setSelectCategory = async () => {
    const categoryOption = [];
    categoryOption.push(
      <Option value={'all'} key={'all'}>
        สินค้าทั้งหมด
      </Option>
    );

    for (let i = 0; i < allCategory.length; i++) {
      categoryOption.push(
        <Option value={allCategory[i]._id} key={allCategory[i]._id}>
          {allCategory[i].name}
        </Option>
      );
    }

    setCategoryOption(categoryOption);
  };

  const getShop = async () => {
    const getShopDetail = await axios.get(
      `${BASE_URL}/shops/get-shop-by-id/${searchParams.get('id')}`
    );
    setFromPage(searchParams.get('from'));
    getPromotion(getShopDetail.data);
    getPromotionProduct(getShopDetail.data);
    setShopDetail(getShopDetail.data);
  };

  const getPromotionProduct = async (shopData: any) => {
    const url = `/promotions/getProductCodeHasPromotion/${shopData.shop.code}`;
    const { data } = await axios.get(url);
    setPromotionProducts(data);
  };

  const getProductByShop = async () => {
    if (loading) return;
    setLoading(true);
    const url = `${BASE_URL}/user-product/get-product-by-shop/${shopId}?category=${category}&sortby=${ordering}&search=${search}&skip=${skip}&limit=${limit}`;
    const response = await axios.get(url);

    if (response.data.products.length < limit || ordering === 'promotion') {
      setHasProducts(false);
    }

    setShopProducts([...shopProducts, ...response.data.products]);
    setSkip(skip + 1);
    setLoading(false);

    if (ordering === 'promotion') {
      changeOrdering('notinpromotion');
    }
  };

  const getAllCategory = async () => {
    const allCategoryData = await axios.get(`${BASE_URL}/categorys`);
    setAllCategory(allCategoryData.data);
  };

  const changeCategory = async (value: any) => {
    setShopProducts([]);
    setSkip(1);
    setHasProducts(true);
    setCategory(value);

    if (ordering === 'notinpromotion') {
      setOrdering('promotion');
    }
  };

  const changeOrdering = async (value: any) => {
    if (value !== 'notinpromotion') {
      setShopProducts([]);
    }
    setSkip(1);
    setHasProducts(true);
    setOrdering(value);
  };

  const searchProduct = async (value: any) => {
    setShopProducts([]);
    setSkip(1);
    setHasProducts(true);
    setSearch(value);

    if (ordering === 'notinpromotion') {
      setOrdering('promotion');
    }
  };

  const checkMemberShop = async () => {
    const shopMember = await axios.get(
      `${BASE_URL}/shop-buyer/shop-buyer-member/${currentUser._id}?shop=${shopId}`
    );
    setIsMember(shopMember.data);
  };

  useEffect(() => {
    if (currentUser._id) {
      const urlParams = new URLSearchParams(window.location.search);
      const autoadd = urlParams.get('autoadd');
      const shopId = urlParams.get('id');
      const isAutoAdd = autoadd === 'true';
      if (isAutoAdd) {
        subscribeShop(currentUser._id, shopId);
      }
    }
  }, [currentUser._id]);

  const subscribeShop = async (userId: any, shopId: any) => {
    const myShop = await axios.get(
      `${BASE_URL}/shop-buyer/shop-buyer/${userId}`
    );

    const myShopData = myShop.data?.find(
      (element: any) => element?.shop?._id === shopId
    );

    if (!myShopData) {
      const data = {
        buyer: userId,
        shop: shopId,
      };

      await axios.post(`${BASE_URL}/shop-buyer`, data);
      navigate('/my-shops');
    }
  };

  const getPromotion = async (items: any) => {
    const data = { sellerId: items?.shop?.code };
    if (items.shop.code) {
      const promotions = await axios.post(`/promotions/seller/has-promotion`, {
        sellers: [data],
      });
      setShopPromotion(promotions);
    }
  };

  const checkPromotion = () => {
    return shopPromotion?.data ? shopPromotion?.data[0]?.joinPromotion : false;
  };

  const redirectMap = () => {
    window.open(
      `https://google.com/maps?q=${shopDetail?.shop?.lat}, ${shopDetail?.shop?.long}`
    );
  };

  const getShopPromotion = () => {
    const text = 'ร้านค้าเข้าร่วมโปรโมชั่น';
    return <div>{shopPromotion?.data[0]?.joinPromotion ? text : ''}</div>;
  };

  const getNavigateBarName = async () => {
    const fromPage = searchParams.get('from');
    switch (fromPage) {
      case 'nearMe':
        setNavigateBarName('ร้านค้าใกล้ฉัน');
        setNavigateBarUrl('/shops/near-me');
        break;
      case 'myShops':
        setNavigateBarName('ร้านค้าของฉัน');
        setNavigateBarUrl('/my-shops');
        break;
      case 'categories':
        setNavigateBarName('หมวดหมู่สินค้า');
        setNavigateBarUrl('/product-categories');
        break;
      default:
        setNavigateBarName('ร้านค้า');
        setNavigateBarUrl('');
        break;
    }
  };

  useEffect(() => {
    if (shopId && currentUser._id) {
      checkMemberShop();
    }
  }, [currentUser._id]);

  useEffect(() => {
    setSelectCategory();
  }, [allCategory]);

  useEffect(() => {
    setShopId(searchParams.get('id'));
    getShop();
    getAllCategory();
    getNavigateBarName();
  }, []);

  useEffect(() => {
    if (shopId) {
      getProductByShop();
    }
  }, [shopId, category, ordering, search]);

  const ShopForm = () => {
    return (
      <>
        <Card bodyStyle={{ padding: '10px' }}>
          <Row>
            <Col xs={24} md={6}></Col>
            <Col xs={24} md={4} className={styles.shopImage}>
              <img src={shopDetail?.shop?.document?.shopImageUrl} alt='' />
            </Col>
            <Col xs={24} md={10} style={{ paddingTop: 10 }}>
              <h1 className={styles.textCenter}>{shopDetail?.shop?.name}</h1>
              <strong className={styles.textCenter}>
                {shopDeliveryText(shopDetail?.shop)}
              </strong>
              <strong className={styles.textCenter}>
                <div className={styles.lineIcon}>
                  <img
                    alt=''
                    src='/images/shops/shop-phone.svg'
                    className={styles.imgIcon}
                    style={{ marginRight: 5 }}
                  />
                </div>
                {!shopDetail?.shop?.phoneNumberReserve ? (
                  <div className={styles.infoText}>
                    <a href={`tel:${shopDetail?.shop?.phoneNumber}`}>
                      <NumberFormat
                        format='###-###-####'
                        value={shopDetail?.shop?.phoneNumber}
                        displayType='text'
                        style={{ color: '#000000' }}
                      ></NumberFormat>
                    </a>
                  </div>
                ) : (
                  <div className={styles.infoText}>
                    <a href={`tel:${shopDetail?.shop?.phoneNumber}`}>
                      <NumberFormat
                        format='###-###-####'
                        value={shopDetail?.shop?.phoneNumber}
                        displayType='text'
                        style={{ color: '#000000' }}
                      ></NumberFormat>
                    </a>
                    &nbsp; /&nbsp;
                    <a href={`tel:${shopDetail?.shop?.phoneNumberReserve}`}>
                      <NumberFormat
                        format='###-###-####'
                        value={shopDetail?.shop?.phoneNumberReserve}
                        displayType='text'
                        style={{ color: '#000000' }}
                      ></NumberFormat>
                    </a>
                  </div>
                )}

                {shopDetail?.shop?.workingTimeStart &&
                  shopDetail?.shop?.workingTimeEnd && (
                    <>
                      <div className={styles.lineIcon}>
                        <img
                          alt=''
                          src='/images/shops/shop-time.svg'
                          className={styles.imgIcon}
                          style={{ marginRight: 5, marginLeft: 10 }}
                        />
                      </div>
                      <div className={styles.infoText}>
                        {shopDetail.shop.workingTimeStart} -{' '}
                        {shopDetail.shop.workingTimeEnd}
                      </div>
                    </>
                  )}
              </strong>
            </Col>
            <Col xs={24} md={4}></Col>
          </Row>
        </Card>
        <Card bodyStyle={{ padding: '10px' }}>
          <Row>
            <Col xs={16} lg={8}>
              <div className={styles.filterText}>ค้นหา</div>
            </Col>
            <Col xs={8} lg={4}>
              <div className={`${styles.filterText} ${styles.catText}`}>
                หมวดหมู่
              </div>
            </Col>
            <Col xs={0} lg={12}>
              <div className={`${styles.filterText} ${styles.sortByText}`}>
                เรียงตาม:
              </div>
            </Col>

            <Col xs={16} lg={8}>
              <Search
                placeholder='ค้นหาสินค้า'
                onSearch={searchProduct}
                enterButton
                allowClear
              />
            </Col>

            <Col xs={8} lg={4}>
              <Select
                className={styles.catSelect}
                placeholder='หมวดหมู่'
                onChange={(e) => changeCategory(e)}
                dropdownMatchSelectWidth={false}
                defaultValue='all'
              >
                {categoryOption}
              </Select>
            </Col>

            <Col xs={24} lg={0}>
              <div className={`${styles.filterText} ${styles.sortByText}`}>
                เรียงตาม:
              </div>
            </Col>

            <Col xs={24} lg={12}>
              <Radio.Group
                onChange={(e) => changeOrdering(e.target.value)}
                defaultValue='promotion'
                buttonStyle='solid'
                className={styles.sortByRadioButton}
              >
                <Radio.Button value='promotion'>โปรโมชั่น</Radio.Button>
                <Radio.Button value='newest'>มาใหม่</Radio.Button>
                <Radio.Button value='price_lowest'>ราคาต่ำ-สูง</Radio.Button>
                <Radio.Button value='price_highest'>ราคาสูง-ต่ำ</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <InfiniteScroll
                dataLength={shopProducts.length}
                next={getProductByShop}
                hasMore={hasProducts}
                loader={
                  <div
                    className={styles.textCenter}
                    style={{
                      marginTop: '30px',
                      marginBottom: '30px',
                    }}
                  >
                    <Spin indicator={antIcon} />
                    &nbsp;&nbsp;กำลังโหลดรายการสินค้า
                  </div>
                }
                style={{ overflow: 'unset', marginTop: '20px' }}
              >
                {shopProducts?.length > 0 ? (
                  <List
                    grid={{
                      gutter: 10,
                      xs: 2,
                      sm: 3,
                      md: 4,
                      lg: 4,
                      xl: 6,
                      xxl: 6,
                      column: 6,
                    }}
                    dataSource={shopProducts}
                    renderItem={(item: any) => (
                      <ProductItem
                        item={item}
                        fromPage={fromPage}
                        promotionProducts={promotionProducts}
                        isMember={isMember}
                      />
                    )}
                  />
                ) : (
                  ''
                )}
              </InfiniteScroll>
            </Col>
          </Row>
          {shopProducts?.length <= 0 ? (
            <Row style={{ textAlign: 'center', padding: '50px 0px' }}>
              <Col span={12} offset={6}>
                <Link to={''} onClick={redirectMap}>
                  <span style={{ fontSize: '20px' }}>เดินทางไปร้าน</span>
                </Link>
                <p style={{ fontSize: '20px' }}>หรือ</p>
                <p style={{ fontSize: '20px' }}>ติดต่อร้านค้าเพื่อซื้อสินค้า</p>
              </Col>
            </Row>
          ) : (
            ''
          )}
        </Card>
      </>
    );
  };

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} containerMaxWidth={1200}>
        {checkPromotion() ? (
          <div>
            <Badge.Ribbon text={getShopPromotion()} color='volcano'>
              {ShopForm()}
            </Badge.Ribbon>
          </div>
        ) : (
          ShopForm()
        )}
      </Layout>
    </>
  );
};

export default Shop;
